import React, { useContext, useEffect } from 'react';
import { useTranslate } from '../../../mixins/translate/translate';
import { useOpenApiFetch } from '../../../store/useOpenApiFetch';
import { appContext } from '../../appContext';
import {
    PanelBody,
    PanelHeading,
    PanelWithoutForm,
    Table,
    TableBody,
    TableData,
    TableHead,
    TableHeader,
    TableHeadRow,
    TableRow,
} from '../../elements';
import { PanelSpinner } from '../../spinners';

type Props = {
    surveyId: string;
    setLeftTrayVisible: (visible: boolean) => void;
};

export function SurveyDetailsEquipmentUsage(props: Props) {
    const currentAppContext = useContext(appContext.context);
    const { customerVersion } = currentAppContext.globalSettings;

    useEffect(() => {
        if (customerVersion === 'ronik') {
            props.setLeftTrayVisible(true);
        } else {
            props.setLeftTrayVisible(false);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps -- TODO: ZXY-1220 SurveyDetails is not yet ready for this.
    }, [customerVersion]);

    if (customerVersion === 'ronik') {
        return <SurveyDetailsEquipmentUsageDetails {...props} />;
    }
    return null;
}

function SurveyDetailsEquipmentUsageDetails(props: Props) {
    const { setLeftTrayVisible } = props;
    const translate = useTranslate();

    const { data } = useOpenApiFetch('/api/equipmentUsage', 'get', { surveyId: props.surveyId }, []);

    useEffect(() => {
        if (data !== undefined && data.length > 0) {
            setLeftTrayVisible(true);
        } else {
            setLeftTrayVisible(false);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps -- TODO: ZXY-1220 SurveyDetails is not yet ready for this.
    }, [data]);

    if (!data) {
        return <PanelSpinner />;
    }
    if (data.length === 0) {
        return null;
    }

    return (
        <PanelWithoutForm id="Equipment">
            <PanelHeading text={`${translate('equipment.usedEquipment')}`} icon="fa fa-plane"></PanelHeading>
            <PanelBody noPadding>
                <Table>
                    <TableHead>
                        <TableHeadRow light={true}>
                            <TableHeader>{translate('common.name')}</TableHeader>
                            <TableHeader>{translate('common.type')}</TableHeader>
                            <TableHeader>{translate('equipment.manufacturer')}</TableHeader>
                            <TableHeader>{translate('equipment.serialNumber')}</TableHeader>
                        </TableHeadRow>
                    </TableHead>
                    <TableBody>
                        {data.map((item) => (
                            <TableRow key={item.id}>
                                <TableData>
                                    {item.equipment.equipmentType.isPayload && <i className="fa fa-long-arrow-right ml20 mr20" />}{' '}
                                    {item.equipment.name}{' '}
                                </TableData>
                                <TableData> {item.equipment.equipmentType.name} </TableData>
                                <TableData> {item.equipment.manufacturer} </TableData>
                                <TableData> {item.equipment.serialNumber} </TableData>
                            </TableRow>
                        ))}
                    </TableBody>
                </Table>
            </PanelBody>
        </PanelWithoutForm>
    );
}
